import './index.css';
import { Provider } from 'react-redux';
import { HashRouter } from 'react-router-dom';
import * as ReactDOMClient from 'react-dom/client';
import {
  AppWrapper,
} from '@equifinance/shared';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { store } from './store';

const container = document.getElementById('root')!;
const root = ReactDOMClient.createRoot(container);

root.render(
  <AppWrapper>
    <Provider store={store}>
      <HashRouter>
        <App />
      </HashRouter>
    </Provider>
  </AppWrapper>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
